import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link, useLocation } from "react-router-dom"
import { signOut } from 'firebase/auth';
import { message } from 'antd';
import { auth } from '../config/firebase';
import { useAuthContext } from '../contexts/AuthContext';
function Header() {
    const theme = createTheme({
        palette: {
            primary: {
                main: '#544343'
            },
            background: {
                default: '#fffa8a',
            },
        },
    });
    const { isAuth, dispatch } = useAuthContext()
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const location = useLocation();
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const logout = () => {
        signOut(auth).then(() => {
            dispatch({ type: "SET_LOGGED_OUT" })
            message.success("Log out Succesfully")
        }).catch((error) => {
            message.error("AN ERROR OCCUR WHILE LOG OUT")
        });
    }
    const [scrollingUp, setScrollingUp] = React.useState(true);
    const [prevScrollY, setPrevScrollY] = React.useState(0);

    React.useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setScrollingUp(currentScrollY < prevScrollY);
            setPrevScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [prevScrollY]);
    return (
        <header className={`header  ${!scrollingUp ? 'scrolling-down' : ''}`}>
            <ThemeProvider theme={theme}>
                <AppBar position="sticky" >
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <Link to={"/"} >
                                <img src={"https://firebasestorage.googleapis.com/v0/b/ilmulquran-762.appspot.com/o/Al-Quran-logo.png?alt=media&token=7b874289-e1cc-4128-bf13-86cf731df2e4"} style={{ width: "50px" }} alt='Logo of limulquran' className='hidden md:flex' />
                                {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
                            </Link>
                            <Typography
                                variant="h6"
                                noWrap
                                sx={{
                                    mr: 2,
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: 'Libre Baskerville',
                                    fontWeight: 700,
                                    // letterSpacing: '.1rem',
                                    color: '#fffa8a',
                                    // textDecoration: 'none',
                                }}
                            >
                                IlmUlQuran
                            </Typography>


                            <Box sx={{ flexGrow: 1, padding: 0, display: { xs: 'flex', md: 'none' } }}>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenNavMenu}
                                    color="inherit"
                                >
                                    <MenuIcon sx={{ backgroundColor: 'transparent', color: '#fffa8a' }} />
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorElNav}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    open={Boolean(anchorElNav)}
                                    onClose={handleCloseNavMenu}
                                    sx={{
                                        display: { xs: 'block', md: 'none' },
                                    }}
                                >
                                    <Link to={"/"}><MenuItem onClick={handleCloseNavMenu} sx={{ backgroundColor: 'black', color: '#fffa8a', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}>
                                        Home
                                    </MenuItem> </Link>
                                    <Link to={"/courses"}><MenuItem onClick={handleCloseNavMenu} sx={{ backgroundColor: 'black', color: '#fffa8a', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}>
                                        Courses
                                    </MenuItem> </Link>
                                    <Link to={"/blogs"}><MenuItem onClick={handleCloseNavMenu} sx={{ backgroundColor: 'black', color: '#fffa8a', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}>
                                        Blogs
                                    </MenuItem> </Link>
                                    <Link to={"/quiz"}><MenuItem onClick={handleCloseNavMenu} sx={{ backgroundColor: 'black', color: '#fffa8a', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}>
                                        Quiz
                                    </MenuItem> </Link>
                                    <Link to={"/contactUs"}><MenuItem onClick={handleCloseNavMenu} sx={{
                                        backgroundColor: 'black', color: '#fffa8a', '&:hover': { backgroundColor: '#fffa8a', color: 'black', }
                                    }}>
                                        Contact Us
                                    </MenuItem> </Link>

                                </Menu>
                            </Box>
                            <Link to={"/"}>
                                <img src={"https://firebasestorage.googleapis.com/v0/b/ilmulquran-762.appspot.com/o/Al-Quran-logo.png?alt=media&token=7b874289-e1cc-4128-bf13-86cf731df2e4"} style={{ width: "50px" }} alt='Logo of limulquran' className='md:hidden flex' />
                            </Link>
                            <Typography
                                variant="h6"
                                noWrap

                                sx={{
                                    mr: 2,
                                    display: { xs: 'flex', md: 'none' },
                                    flexGrow: 1,
                                    fontFamily: 'Libre Baskerville',
                                    fontWeight: 700,
                                    // letterSpacing: '.1rem',
                                    color: '#fffa8a',
                                    textDecoration: 'none',
                                }}
                            >
                                IlmUlQuran
                            </Typography>
                            <Box sx={{
                                flexGrow: 1, justifyContent: 'center', background: "transparent", display: { xs: 'none', md: 'flex' }
                            }}>
                                <Link to={"/"}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, mx: 2, color: '#fffa8a', display: 'block', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}
                                    >
                                        Home
                                    </Button>
                                </Link>
                                <Link to={"/courses"}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, mx: 2, color: '#fffa8a', display: 'block', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}
                                    >
                                        Courses
                                    </Button>
                                </Link>
                                <Link to={"/blogs"}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, mx: 2, color: '#fffa8a', display: 'block', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}
                                    >
                                        Blogs
                                    </Button>
                                </Link>
                                <Link to={"/quiz"}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, mx: 2, color: '#fffa8a', display: 'block', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}
                                    >
                                        Quiz
                                    </Button>
                                </Link>
                                <Link to={"/contactUs"}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, mx: 2, color: '#fffa8a', display: 'block', '&:hover': { backgroundColor: '#fffa8a', color: 'black', } }}
                                    >
                                        Contact Us
                                    </Button>
                                </Link>
                            </Box>

                            <Box sx={{ flexGrow: 0 }}>
                                {
                                    isAuth && location.pathname.startsWith('/dashboard') ? (
                                        <Button
                                            
                                            className="px-10 mx-auto text-center rounded-2xl hover:rounded-lg"
                                            onClick={logout}
                                            style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }}
                                        >
                                            Logout
                                        </Button>
                                    ) : isAuth ? (<Link to={"/dashboard"}>
                                        <Button
                                            
                                            className="px-10 mx-auto text-center rounded-2xl hover:rounded-lg"
                                            style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }}
                                        >
                                            Dashboard
                                        </Button></Link>
                                    ) : (<Link to={"/auth/login"}>
                                        <Button
                                            
                                            className="px-10 mx-auto text-center rounded-2xl hover:rounded-lg"
                                            style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }}
                                        >
                                            Login
                                        </Button>
                                    </Link>
                                    )
                                }

                            </Box>
                        </Toolbar>
                    </Container>
                </AppBar >
            </ThemeProvider>
        </header>
    );
}
export default Header;